
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class UnderlineForm extends Vue {
    @Prop({required: true})
    beforetext!: string;
    @Prop({required: true})
    text!: string;
    @Prop({required: true})
    hint!: string;
    @Prop({required: true})
    textwidth!: string;
    @Prop({required: false, default: true})
    italicHint!: boolean;
    @Prop({required: false, default: '8pt'})
    hintFontSize!: string;
}
